import { Component, OnInit } from '@angular/core';
import { UrlService } from 'src/app/services/Url.service';
import { MsalService } from '@azure/msal-angular';
@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false,
})
export class PageNotFoundComponent implements OnInit {
    isUserLoggedIn: any;

    constructor(
        private urlService: UrlService,
        private msalSerice: MsalService
    ) {}

    ngOnInit(): void {
        this.isUserLoggedIn = this.msalSerice.instance.getActiveAccount();
    }

    backurl() {
        this.urlService.back();
    }
}
